// 案例數據
export const caseStudies = [
  {
    id: "poc-custom-dev",
    category: "integration",
    title: "概念驗證與客製化開發",
    client: "多家企業客戶",
    summary:
      "從實際場域需求出發，提供AI與軟硬體整合的客製化開發服務，快速完成原型驗證並支援後續擴充與產品化，協助客戶加速導入智慧系統、實現創新落地。",
    description:
      "聚焦於概念驗證（POC）與客製化智慧系統開發，從實際場域需求出發，結合 AI 演算法與軟硬體整合能力，打造符合客戶需求的專屬應用解決方案。透過模組化開發流程與使用者協作，快速建立原型系統，進行功能驗證與調整，並於現場環境中進行測試與優化。系統架構具備高度彈性與擴充性，支援資料串接與功能擴展，有助於後續產品化與規模部署。專案同時涵蓋從需求釐清、設計實作、模型訓練到測試上線的完整流程，協助客戶有效驗證創新構想、縮短開發時程，實現智慧應用的實地導入與長期營運。。",
    tags: ["客製化開發", "AI 演算法", "軟硬體整合"],
    achievements: [
      {
        label: "與客戶共同釐清需求與設計規格，快速進入原型製作",
        value: "快速原型製作",
      },
      {
        label: "透過小樣本訓練與模擬驗證，有效驗證演算法準確性與效能",
        value: "AI模型導入加速",
      },
      {
        label: "於實際應用場景中測試，依回饋調整功能與UI/UX",
        value: "跨模組整合完成",
      },
      {
        label: "於實際應用場景中測試，依回饋調整功能與UI/UX",
        value: "實地驗證與優化",
      },
      {
        label: "預留API與資料串接介面，支援後續產品化與規模化導入",
        value: "可擴充應用架構",
      },
      {
        label: "導入現場持續運作，並提供維運與更新服務，確保系統穩定與即時應用",
        value: "系統穩定上線",
      },
      {
        label: "協助團隊從創意走向實作，形成具體可用的智慧應用解決方案",
        value: "落實創意構想落地",
      },
    ],
    clients: [
      "泉創生醫 - VitaPCR資料傳輸系統",
      "高雄醫學大學 - 衛生局web crawler程式開發",
      "高雄醫學大學創心力團隊 - 心力手環APP開發",
      "理略生物科技 - Ultrasound Needle Guide",
    ],
    details: {
      challenges: [
        "應用情境複雜，需求難以明確定義",
        "傳統開發模式無法快速驗證構想可行性",
        "系統需同時整合硬體、韌體與演算法設計",
        "缺乏具實務經驗的技術整合夥伴",
        "無法即時依現場狀況調整功能與介面",
        "缺乏長期維運與持續優化能力",
      ],
      highlights: [
        "模組化開發架構，支援快速原型製作",
        "AI 演算法與硬體設備無縫整合",
        "預留擴充介面，支援後續產品化發展",
        "實地驗證機制，確保系統實用性",
      ],
    },
    featured: true,
  },
  {
    id: "icu-aiot-system",
    category: "medical",
    title: "加護病房聲音偵測 AIoT 系統",
    client: "中山醫學大學附設醫院",
    summary:
      "專為 ICU 打造，透過聲音 AI 辨識設備異常音，能自動觸發護士鈴與燈號提醒，即使人不在病床旁也能即時掌握狀況。有效提升警報反應效率、降低護理負擔，強化病患安全，是智慧病房不可或缺的好幫手。",
    description:
      "本專案針對加護病房（ICU）量身打造 AIoT 警報輔助系統，運用聲音 AI 技術即時辨識各式醫療設備的異常警示音，並自動觸發護士鈴及燈號顯示，有效強化警報反應機制。面對 ICU 中護病比高、設備眾多且環境噪音複雜等挑戰，本系統能智慧監控多床位、多點位的設備警報，即使護理人員不在病床旁也能即時得知異常，迅速做出應對。系統可 24 小時運行，支援與既有護理站、呼叫系統整合，大幅提升警報準確率與反應效率。整體設計聚焦於減輕護理壓力、降低醫療風險，並提升病患安全與醫療品質，為 ICU 實現更高效、智慧化的照護流程。",
    tags: ["AI 語音辨識", "IoT 應用", "智慧醫療", "即時監控"],
    achievements: [
      {
        label: "從平均 5-8 分鐘縮短至 1 分鐘內",
        value: "警報反應時間縮短 85%",
      },
      { label: "由原本約 20% 降至 1% 以下", value: "警報遺漏率降低 95%" },
      {
        label: "減少不必要的巡房頻率，優化人力配置",
        value: "護理工作效率提升 30%",
      },
      {
        label: "即時警報機制確保危急狀況第一時間獲得處置",
        value: "緊急事件處理速度提升",
      },
      {
        label: "無論護理人員位於病房內、走廊或護理站均能接收警報",
        value: "多點位覆蓋",
      },
      {
        label: "AI 系統提供全天候智慧監護服務",
        value: "24 小時不間斷監控",
      },
      {
        label: "減少因延遲處置導致的醫療糾紛風險",
        value: "降低醫療風險",
      },
      {
        label: "減輕護理人員工作壓力與心理負擔",
        value: "提升護理滿意度",
      },
      {
        label: "精準警報系統提升整體病房管理效率",
        value: "優化資源配置",
      },
    ],
    clients: ["中山醫學大學附設醫院亞 - 急性呼吸病房警報系統"],
    details: {
      challenges: [
        "ICU 病房環境噪音複雜，多種醫療設備同時運作",
        "護病比失衡導致護理人員長時間在病床旁照護患者",
        "傳統中央監護站警報系統有反應延遲問題",
        "護理人員無法即時察覺其他病床(房)的設備異常警報",
      ],
      highlights: [
        "AI 聲音辨識演算法，精準識別複雜環境中的醫療設備警報",
        "多點位覆蓋系統，確保全區域監控無死角",
        "即時警示機制，支援多種通知方式",
        "降低醫療風險，提升護理滿意度",
      ],
    },
    featured: true,
  },
  {
    id: "anxin-ecg-system",
    category: "medical",
    title: "安心摩爾：救護車 ECG 即時上傳系統",
    client: "屏東消防局",
    summary:
      "讓急救人員在現場或救護車行駛途中即能傳送心電圖，醫師遠端判讀後直接送病患到能做心導管的醫院，減少轉院時間。系統可與 HIS/PACS 串接，幫助醫院提早準備，把握黃金搶救時機，有效提升急救效率與病患存活率。",
    description:
      "本系統旨在提升急性心肌梗塞（STEMI）急救效率，透過將心電圖檢查前移至救護現場，結合即時數據上傳與後端醫師遠距判讀，協助救護人員於第一時間完成初步診斷與決策。系統可依判讀結果選擇具備心導管處置能力的醫院直送，大幅減少不必要的轉院與等待時間。整合行動裝置與醫院 HIS/PACS 系統，不僅實現資訊即時傳遞，也讓醫療端可於病患尚未到院前即完成準備。藉由數位化與智慧化的作業流程，「到院前心電圖系統」有效爭取黃金救治時間，提升 STEMI 病患存活率與整體醫療品質，是救護與醫療體系協作升級的關鍵解決方案。",
    tags: ["緊急醫療", "即時傳輸", "遠距診斷", "系統整合"],
    achievements: [
      { label: "現場完成初步診斷與決策", value: "急救決策效率提升超過 70%" },
      {
        label: "病患未到院，醫療端即已完成準備",
        value: "醫療啟動時間提前 10-20 分鐘 ",
      },
      {
        label: "可直接送至具備處置能力之醫院，避免二次轉院",
        value: "降低轉送率",
      },
      { label: "急救人員與後端醫療團隊無縫溝通", value: "資訊即時傳遞" },
      {
        label: "即時判讀與標準化資料傳輸提高診斷準確率",
        value: "提升診斷準確率",
      },
      { label: "到院即治療，減少等待與焦慮時間", value: "改善病患體驗" },
    ],
    clients: ["屏東消防局（與當地醫療體系合作導入）"],
    details: {
      challenges: [
        "現行急救流程難以實現在黃金90分鐘內進行血管再灌流治療",
        "若送至無心導管設備的醫院則需二次轉院",
        "無法於送醫過程中即時確認是否為 STEMI 案例",
        "醫院無法預先調度資源，延後心導管室啟動",
      ],
      highlights: [
        "即時心電圖影像上傳與判讀平台建置",
        "可與醫院 HIS/PACS 系統串接，完整病歷整合",
        "兼具行動裝置與主機端同步操作能力",
        "降低誤診風險，提高診斷準確率",
      ],
    },
    featured: true,
  },
  {
    id: "jpr-ecg-management",
    category: "medical",
    title: "JPR-全流程心電圖數位化管理系統",
    client: "屏東基督教醫院",
    summary:
      "整合急診、門診、健檢等科室影像，自動媒合檢查單、加速報告產出與申報流程，還能無縫串接 PACS、HIS 系統，協助醫院提升作業效率與資料一致性，建立一站式心電圖數位化管理平台也同時是心電圖數位化的重要基礎建設。",
    description:
      "從影像收集、自動媒合、檢視查詢到報告編寫，全面數位化心電圖作業流程。系統可與醫院既有的 PACS、HIS 完整整合，統一管理來自急診、門診、健檢等各科室的心電圖影像，避免資料分散與錯配問題。透過自動媒合與影像整合技術，有效減少人工作業時間，提升報告產出效率與查詢速度。平台並具備自動上傳與申報機制，簡化健保行政流程，減少錯誤發生率。此外，系統內建存取權限與備份機制，強化醫療資料的安全性與一致性，協助醫院提升醫療品質與服務效率，是推動醫療資訊數位轉型的重要基礎建設。",
    tags: ["PACS 整合", "自動化流程", "數位轉型", "醫療資訊"],
    achievements: [
      {
        label: "自動 QC 媒合功能大幅減少人工作業時",
        value: "影像處理效率提升 85%",
      },
      {
        label: "自動影像合併與上傳機制顯著提升工作效率",
        value: "報告編寫時間縮短 60%",
      },
      {
        label: "統一檢視平台讓各科室快速存取所需資料",
        value: "查詢回應速度提升 90%",
      },
    ],
    clients: ["屏東基督教醫院"],
    details: {
      challenges: [
        "心電圖影像來源分散，包含急診、一般檢查、健康檢查等多個科室",
        "人工媒合作業耗時費力，容易產生錯誤配對",
        "缺乏統一的影像檢視平台，各單位查詢困難",
        "報告編寫流程繁複，影像整合作業效率低下",
        "與既有 PACS 和 HIS 系統整合度不足",
        "健保申報流程繁瑣，增加行政負擔",
      ],
      highlights: [
        "一站式服務，從影像收集到報告完成的完整數位化流程",
        "跨科室整合，急診、門診、健檢等所有單位共用統一平台",
        "無縫整合 PACS、HIS 系統，確保資料一致性",
        "完整的資料備份與存取權限管理機制",
      ],
    },
    featured: false,
  },
  {
    id: "vital-signs-integration",
    category: "medical",
    title: "生理監視器整合上傳系統",
    client: "衛生福利部醫院體系",
    summary:
      "透過「掃描、量測、確認」三步驟簡化操作流程，讓護理人員能快速將生理數據自動上傳到NIS，有效提升工作效率、降低錯誤，是打造智慧病房的好幫手。",
    description:
      "本專案開發的「生理監視器數據自動上傳系統」，以「掃描、量測、確認」三步驟簡化護理工作流程，協助醫院將病患的生理數據（如血壓、心率、體溫、血氧等）即時整合進入護理資訊系統（NIS）。此系統解決傳統病房量測需手抄再輸入的繁瑣流程，減少人工錯誤、縮短作業時間，大幅提升護理人員工作效率。實際導入醫院後，平均每位護理人員每天可節省近一小時資料處理時間，同時也讓臨床數據更加即時、完整與準確。系統能與既有設備無縫整合，不需更換硬體，讓醫院以最小成本完成智慧化升級，有效提升整體照護品質與病人安全，是落實智慧病房與優化護理流程的關鍵方案。",
    tags: ["護理資訊", "自動上傳", "流程優化", "數據整合"],
    achievements: [
      {
        label: "量測時間從5分鐘縮短至1.5分鐘，護理人員每日節省1小時登錄時間",
        value: "工作效率提升 70%",
      },
      {
        label: "降低人工錯誤率，即時上傳減少資料遺失風險",
        value: "數據準確性改善",
      },
      {
        label: "整合監視器與護理系統，支援多項生理參數自動擷取",
        value: "系統整合完成",
      },
      { label: "三步驟完成：掃描 → 量測 → 上傳", value: "流程大幅簡化" },
    ],
    clients: ["衛生福利部新營醫院", "衛生福利部臺中醫院"],
    details: {
      challenges: [
        "傳統醫院病房生理量測作業流程繁瑣",
        "護理人員需手動記錄各項生理數據後再逐一輸入護理資訊系統",
        "不僅耗時費力，也容易產生人為錯誤",
        "醫院面臨護理人力緊縮的挑戰",
      ],
      highlights: [
        "三步驟簡化流程：掃描病人編號手圈 → 生理量測 → 確認上傳",
        "成功整合現有生理監視器設備與護理資訊系統",
        "支援多種生理參數自動擷取",
        "即時數據傳輸，確保資料完整性",
      ],
    },
    featured: false,
  },
  {
    id: "physio-measurement-system",
    category: "medical",
    title: "生理測量整合上傳系統",
    client: "國軍桃園總醫院等",
    summary:
      "整合血壓計、身高體重計等多種生理量測設備，操作簡單又直覺，量測數據可即時上傳並同步進醫療系統，大幅提升醫療機構量測效率與數據管理品質，也讓民眾就醫更便利安心。",
    description:
      "本系統整合多種常見的生理量測設備（如血壓計、身高體重計等），提供直覺化的觸控操作介面，並支援健保卡插卡或手動輸入，讓民眾與護理人員都能快速完成量測。量測完成後，數據會即時儲存、上傳，並可同步分享給病患或醫療人員，協助機構提升整體作業效率與資料準確率。過去醫療現場普遍存在設備各自獨立、操作繁瑣、資料無法即時整合等問題，導致人力負擔大、數據追蹤困難。導入本系統後，不僅簡化量測流程，也能將所有資料整合進現有醫療資訊系統，有效提升智慧醫療服務水準，減少人為錯誤與重工負擔，並讓民眾享有更便利與安心的就醫體驗。",
    tags: ["設備整合", "智慧身份識別", "即時處理", "多元分享"],
    achievements: [
      {
        label: "整合式操作介面讓單次量測時間從平均 5 分鐘縮短至 2 分鐘",
        value: "操作效率提升 60%",
      },
      { label: "自動化數據傳輸減少人工抄寫錯誤", value: "數據準確性提升 85%" },
      { label: "統一管理平台提高設備使用效率", value: "設備利用率提升 40%" },
      { label: "自動化流程減少護理人員重複性工作", value: "人力成本節省 30%" },
    ],
    clients: [
      "國軍桃園總醫院 - 血壓計量測上傳系統",
      "大檜溪社區發展協會 - 血壓計量測上傳系統",
      "禾悅診所 - 血壓計量測上傳系統",
    ],
    details: {
      challenges: [
        "設備整合困難：血壓機、身高體重機等生理量測設備各自獨立運作",
        "操作流程複雜：民眾與護理人員需要分別操作不同設備",
        "數據管理分散：量測結果無法即時整合到醫院資訊系統中",
        "使用者體驗不佳：缺乏直觀的操作介面",
        "數據追蹤困難：無法有效追蹤患者的長期生理數據變化趨勢",
      ],
      highlights: [
        "多設備整合：成功整合血壓機、身高體重機等多種生理量測設備",
        "智慧身份識別：支援健保卡插卡自動識別與手動輸入編號",
        "即時數據處理：量測結果立即顯示、儲存與處理",
        "友善操作介面：直觀的觸控式操作介面，適合不同年齡層使用者",
      ],
    },
    featured: false,
  },
  {
    id: "ecg-image-conversion",
    category: "medical",
    title: "心電圖影像轉檔與上傳系統",
    client: "多家醫療機構",
    summary:
      "為多家醫療機構開發之客製化心電圖影像轉檔與上傳系統，協助診間即時完成心電圖影像轉檔與上傳，免除繁複流程與人工處理， 並支援多款設備，快速建檔、提高醫院心電圖檢查流程效率，讓醫護專注照護、作業更順暢。",
    description:
      "為多家醫療機構量身打造心電圖影像轉檔與上傳系統，協助診間即時完成 DICOM 格式轉換、病患檢查單媒合與 PACS 系統上傳。透過輕量化部署與彈性整合能力，免除大型系統導入的高成本與複雜流程，讓現場醫護人員可於第一時間完成心電圖資料處理與建檔，大幅簡化作業流程、提升工作效率。系統相容多種品牌心電圖設備，整合既有 HIS 與 PACS 平台，不僅節省後續維運人力，也加速醫療資料電子化進程。導入後，醫護人員可專注於病患照護，後端資訊自動同步上傳，提升診間運作流暢度與整體醫療品質。",
    tags: ["DICOM 轉檔", "PACS 整合", "輕量化部署", "即時處理"],
    achievements: [
      {
        label: "平均減少 70% 的心電圖檢查後處理時間",
        value: "平均流程時間縮短 70%",
      },
      {
        label: "達到 100% 的 DICOM 格式轉換成功率",
        value: "資料轉換準確率 100%",
      },
      {
        label: "100% 相容現有 PACS 系統，無需額外硬體投資",
        value: "系統整合度 100%",
      },
      {
        label: "平均 1-3 個工作日完成系統導入，較傳統大型系統節省 80% 部署時間",
        value: "部署時間節省 80%",
      },
    ],
    clients: [
      "臺北榮民總醫院臺東分院 - 影像轉檔軟體",
      "成功大學醫學院附設醫院斗六分院 - 心電圖上傳系統",
      "屏安醫療社團法人屏安醫院 - 心電圖上傳系統",
      "部立桃園醫院健檢中心 - 心電圖傳輸系統",
    ],
    details: {
      challenges: [
        "心電圖機設備多樣化，缺乏統一的資料格式轉換機制",
        "檢查資料需手動處理，無法即時整合至醫院資訊系統",
        "PACS (Picture Archiving and Communication System) 上傳流程繁複",
        "診間作業流程不順暢，影響醫護人員工作效率",
        "缺乏彈性的系統整合方案，大型系統導入成本過高",
      ],
      highlights: [
        "輕量級解決方案，無需導入大型系統即可立即提供完整服務",
        "支援多種心電圖機設備的資料格式轉換",
        "即時 DICOM 轉檔與 PACS 上傳功能",
        "快速部署，大幅降低系統導入成本",
      ],
    },
    featured: false,
  },
  {
    id: "jaundice-digital-system",
    category: "medical",
    title: "黃疸測定儀數位化整合系統",
    client: "全台數十家醫院",
    summary:
      "自 2010 年至今持續運作於全台數十家醫院，協助黃疸測定儀數據自動上傳至醫療系統，省去人工抄寫流程，提升檢驗效率並降低錯誤率，已穩定服務全台多家醫院超過13年，深獲醫護肯定。",
    description:
      "專為黃疸測定儀數位化應用設計，透過客製化開發連線程式，實現檢測數據自動上傳至醫院資訊系統。從 2010 年至今，已穩定服務全台數十家醫療院所，成功協助臨床單位省去人工抄寫與輸入流程，不僅大幅提升檢驗效率，更有效降低人為錯誤風險。系統具備高度相容性，可依不同醫院需求調整操作流程並整合至 HIS／LIS，協助醫院建立標準化作業流程，全面強化檢驗資料管理效能。長達 13 年的穩定運作也證明其高可靠性與低維護成本，是目前醫療機構導入儀器資料整合的實用解決方案之一，深受醫檢人員與護理人員肯定。",
    tags: ["數位化轉型", "自動化上傳", "長期運作", "標準化流程"],
    achievements: [
      {
        label: "覆蓋全台數十家醫院，2010 年至今超過 13 年穩定運作",
        value: "服務範圍廣泛",
      },
      {
        label: "檢驗數據處理時間減少 80%，人為輸入錯誤率降低 95% 以上",
        value: "效率大幅提升",
      },
      {
        label: "每家醫院年均節省人力成本 15-20%，維護成本低廉",
        value: "成本效益顯著",
      },
      {
        label: "制定專屬 SOP 提升作業一致性，成功整合現有 HIS/LIS 系統",
        value: "流程標準優化",
      },
      {
        label: "確保檢測數據完整性與準確性，長期運作無重大系統故障",
        value: "數據品質保障",
      },
      {
        label: "獲醫護人員高度肯定，操作便利性與技術穩定性大幅提升",
        value: "使用者高滿意度",
      },
    ],
    clients: [
      "台大醫院附設醫院體系(總院、兒童醫院、新竹、生醫竹北、生醫竹中、虎尾、斗六)",
      "高雄醫學大學附設醫院體系(總院、岡山分院、原市大同)",
      "榮民總醫院體系(台北、台中)",
      "奇美醫院體系(永康、柳營)",
      "慈濟醫院體系(台中、花蓮、大林、嘉義、高雄)",
      "長庚紀念醫院體系(基隆、台北、桃園)",
      "台北市聯合醫院",
      "部立土城醫院",
      "阮綜合醫院",
      "屏東基督教醫院",
      "成大醫院",
      "亞東醫院",
    ],
    details: {
      challenges: [
        "數據孤島問題：檢測儀器產生的數據無法直接整合至醫院資訊系統",
        "人工作業負擔：檢驗人員需手動記錄和輸入數據，容易產生錯誤且耗時",
        "流程標準化需求：不同醫院的檢驗科和臨床單位需要客製化的操作流程",
        "資料管理效率：缺乏統一的數據格式和上傳機制",
      ],
      highlights: [
        "超過 13 年穩定運作經驗，技術成熟可靠",
        "覆蓋全台數十家知名醫院，包含各大醫院體系",
        "自動化數據擷取與上傳，大幅降低人為錯誤",
        "客製化 SOP 制定，滿足不同醫院需求",
      ],
    },
    featured: true,
  },
  {
    id: "restroom-smart-sensor",
    category: "iot",
    title: "廁間智慧感測系統",
    client: "高雄市立小港醫院",
    summary:
      "結合磁簧感測與紅外線動作偵測，透過邏輯判斷演算法，即時掌握使用者狀態，若出現異常（如長時間無活動）將自動警示通知，協助院方即時掌握異常狀況，提升病患、家屬如廁安全與照護品質。",
    description:
      "「廁間智慧感測系統」結合磁簧感測與紅外線動作偵測，能即時掌握使用者在廁間內的狀態，透過邏輯判斷演算法，辨識是否出現異常（如長時間無活動）。當偵測到潛在突發狀況時，系統可自動觸發警示機制，協助院方醫護人員即時反應與處置，守護獨自如廁者的安全。",
    tags: ["IoT 感測", "智慧運算", "安全監控", "即時警示"],
    achievements: [
      {
        label: "即時判斷廁間人體活動，長時間無動作自動觸發警示通知醫護人員",
        value: "安全監控與警示",
      },
      {
        label: "融合磁簧開關與PIR感測器，多層判斷邏輯降低誤判率提升準確性",
        value: "智慧運算偵測",
      },
      {
        label: "成功協助早期發現異常狀況並即時介入處置，建立廁間安全監控示範",
        value: "實際導入成效",
      },
      {
        label: "門關閉狀態無動作時系統自動進入監測邏輯模式運作",
        value: "自動模式切換",
      },
    ],
    clients: ["高雄市立小港醫院"],
    details: {
      challenges: [
        "獨自就醫的患者，若在如廁期間因跌倒、昏厥等突發狀況導致無法自行求助",
        "極易錯失黃金搶救時間",
        "公用廁間多數使用者避免打擾他人，異常狀況常常難以被即時發現",
        "形成潛在風險與安全死角",
      ],
      highlights: [
        "融合磁簧感測與紅外線動作偵測雙重技術",
        "智慧運算與邏輯判斷演算法，提升偵測準確性",
        "自動化警示機制，無需人工介入",
        "多層判斷邏輯，有效降低誤判與漏報率",
      ],
    },
    featured: false,
  },
];

// 分類資訊
export const categories = [
  { id: "all", name: "全部案例", count: caseStudies.length },
  {
    id: "medical",
    name: "醫療",
    count: caseStudies.filter((c) => c.category === "medical").length,
  },
  { id: "sports", name: "運動", count: 0 }, // 暫無運動案例
  { id: "bi", name: "商業智慧", count: 0 }, // 暫無商業智慧案例
  {
    id: "iot",
    name: "IoT",
    count: caseStudies.filter((c) => c.category === "iot").length,
  },
  {
    id: "integration",
    name: "系統整合",
    count: caseStudies.filter((c) => c.category === "integration").length,
  },
];
